import { useRootStore } from '~/store/root'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import { useExperimentsStore } from '~/store/experiments'

const EXPERIMENT_NAMES = {
  embedded: 'EM - Non-linear Application | June 2026',
  il: 'IL - Non-linear Application | June 2026',
  marketplace: 'Non-linear Application | June 2026',
}

export function useNonLinearExperiment() {
  const rootStore = useRootStore()
  const affiliateStore = useAffiliateCustomizationStore()
  const experimentsStore = useExperimentsStore()

  function getExperimentName() {
    if (rootStore.isEmbedded) return EXPERIMENT_NAMES.embedded
    if (affiliateStore.isIntelligentLendingAffiliate) return EXPERIMENT_NAMES.il
    return EXPERIMENT_NAMES.marketplace
  }

  function isNonLinearExperimentActive() {
    const name = getExperimentName()
    return Boolean(experimentsStore.activeUserExperimentByName(name))
  }

  return { isNonLinearExperimentActive }
}
